import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ToolbarTop.css';
import { getAuth } from 'firebase/auth';
import { FaBell, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import {
  getFirestore,
  doc,
  onSnapshot,
  collection,
  query,
  where,
} from 'firebase/firestore';
import OverdueAppointments from '../OverdueAppointments';

function ToolbarTop() {
  const auth = getAuth();
  const user = auth.currentUser;
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState(
    user?.displayName || 'Usuário'
  );
  const [notificationCount, setNotificationCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [latestNotifications, setLatestNotifications] = useState([]);
  const [photoURL, setPhotoURL] = useState(user?.photoURL || '');

  useEffect(() => {
    if (user) {
      const db = getFirestore();
      const userRef = doc(db, 'users', user.uid);

      const unsubscribeUser = onSnapshot(userRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
          const { titulo, nome, photoURL } = docSnapshot.data();
          setDisplayName(
            titulo && titulo !== 'Outros' ? `${titulo} ${nome}` : nome
          );
          setPhotoURL(photoURL || '');
        }
      });

      const agendaQuery = query(
        collection(db, 'agenda'),
        where('userId', '==', user.uid),
        where('dataHora', '<', new Date())
      );

      const unsubscribeNotifications = onSnapshot(agendaQuery, (snapshot) => {
        const pendingNotifications = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          dataHora: doc.data().dataHora.toDate(),
        }));

        setNotificationCount(pendingNotifications.length);
        setLatestNotifications(pendingNotifications.slice(0, 3));
      });

      return () => {
        unsubscribeUser();
        unsubscribeNotifications();
      };
    }
  }, [user]);

  const handleSignOut = () => {
    auth
      .signOut()
      .then(() => {
        window.location.href = '/login';
      })
      .catch((error) => {
        console.error('Erro ao sair:', error);
      });
  };

  const goToProfile = () => {
    navigate('/perfil-de-usuario');
  };

  return (
    <div className="toolbar-top">
      <div
        className="toolbar-left"
        role="button"
        tabIndex={0}
        onClick={goToProfile}
        onKeyPress={(e) => e.key === 'Enter' && goToProfile()}
      >
        <div className="profile-info">
          {photoURL ? (
            <img
              src={photoURL}
              alt="Foto do perfil"
              className="profile-photo"
            />
          ) : (
            <FaUserCircle className="profile-icon" />
          )}
          <div className="profile-details">
            <span className="profile-name">{displayName}</span>
          </div>
        </div>
      </div>
      <div className="toolbar-right">
        {notificationCount > 0 && (
          <div
            className="notification-wrapper"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <div className="notification-icon-wrapper">
              <FaBell className="icon" title="Notificações" />
              <span className="notification-count">{notificationCount}</span>
            </div>
          </div>
        )}
        {showNotifications && (
          <OverdueAppointments
            notifications={latestNotifications}
            onClose={() => setShowNotifications(false)}
          />
        )}
        <FaSignOutAlt
          className="icon logout-icon"
          title="Sair"
          onClick={handleSignOut}
        />
      </div>
    </div>
  );
}

export default ToolbarTop;
